__webpack_require__.p = "/insultorpraise/";